module.exports = __webpack_public_path__ + "static/img/101.2deb222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/190912/101.jpg
// module id = J+CG
// module chunks = 0